/**
 * 클라이언트에서 쿠키 값을 가져오는 유틸리티 함수
 */
export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    // SSR 환경에서는 null 반환
    return null
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null
  }
  
  return null
}

/**
 * rlAccessToken 쿠키가 존재하는지 체크
 */
export const hasAccessToken = (): boolean => {
  const token = getCookie('rlAccessToken')
  return Boolean(token && token.trim() !== '')
}

/**
 * rlRefreshToken 쿠키가 존재하는지 체크
 */
export const hasRefreshToken = (): boolean => {
  const token = getCookie('rlRefreshToken')
  return Boolean(token && token.trim() !== '')
}

/**
 * 인증 토큰들이 모두 존재하는지 체크
 */
export const hasValidTokens = (): boolean => {
  return hasAccessToken() && hasRefreshToken()
}

/**
 * 쿠키를 설정하는 함수
 */
export const setCookie = (
  name: string,
  value: string,
  options: {
    maxAge?: number
    path?: string
    secure?: boolean
    sameSite?: 'strict' | 'lax' | 'none'
  } = {}
): void => {
  if (typeof document === 'undefined') {
    return
  }

  const {
    maxAge,
    path = '/',
    secure = process.env.NODE_ENV === 'production',
    sameSite = 'strict'
  } = options

  let cookieString = `${name}=${value}; path=${path}; SameSite=${sameSite}`
  
  if (maxAge) {
    cookieString += `; max-age=${maxAge}`
  }
  
  if (secure) {
    cookieString += '; secure'
  }

  document.cookie = cookieString
}

/**
 * 쿠키를 삭제하는 함수
 */
export const deleteCookie = (name: string, path: string = '/'): void => {
  if (typeof document === 'undefined') {
    return
  }

  document.cookie = `${name}=; path=${path}; max-age=0; SameSite=strict`
}